module.exports = "<ng-content></ng-content>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-filter-control.component.html
// module id = 436
// module chunks = 11